import React, { useState } from "react";
import "./Certificate.css";

import { Container, Row, Col } from "react-bootstrap";
import InquiryFormModal from "../../common_components/InquiryFormModal/InquiryFormModal";

const Certificate = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <section className="certificate_section">
      <Container>
        <Row className="align-items-center">
          {/* Left Content */}
          <Col lg={5} md={6}>
            <div className="certificate_content">
              <h5>Turn Your Learning into a</h5>

              <h2>
                Recognized
                <br />
                Credential.
              </h2>

              <button
                className="certificate_btn"
                onClick={() => setShowModal(true)}
              >
                Apply Now
              </button>
            </div>
          </Col>

          {/* Right Image */}
          <Col lg={7} md={6}>
            <div className="certificate_img">
              <img
                src="/assets/images/online_mba/ATLAS_Certificate.webp"
                alt="Certificate"
                className="img-fluid"
              />

              <p>Sample Certification</p>
            </div>
          </Col>
        </Row>
      </Container>

      <InquiryFormModal
        show={showModal}
        onHide={() => setShowModal(false)}
      />
    </section>
  );
};

export default Certificate;